import type { EventRow } from "../types/event";

const sampleData: EventRow[] = [
  {
    id: "1",
    title: "Sessão de CRO para Embaixadores – Onboarding",
    description: "Boas práticas, métricas chave e primeiras ações para a rede de embaixadores. Uma sessão completa para começar com o pé direito.",
    start_iso: new Date(Date.now() + 72 * 60 * 60 * 1000).toISOString(),
    end_iso: new Date(Date.now() + 74 * 60 * 60 * 1000).toISOString(),
    location_type: "online",
    location_name: "Google Meet",
    join_url: "https://meet.google.com/abc-defg-hij",
    rsvp_url: "https://forms.gle/example123",
    speakers: "Ygor Amaral, Taci Campos",
    tags: "CRO, Analytics, Onboarding",
    cover_image: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800",
    status: "scheduled",
    series: "CRO Talks",
    episode: "#01",
    destaque: "Sim"
  },
  {
    id: "2",
    title: "Growth Tático – Casos práticos de sucesso",
    description: "Exemplos reais de growth de baixo custo aplicados pelos embaixadores. Cases de sucesso e lições aprendidas.",
    start_iso: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    end_iso: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000 + 60 * 60 * 1000).toISOString(),
    location_type: "online",
    location_name: "YouTube Live",
    join_url: "https://youtube.com/live/example",
    recording_url: "https://youtube.com/watch?v=example123",
    speakers: "Convidados especiais da comunidade",
    tags: "Growth, Conteúdo, Cases",
    cover_image: "https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&w=800",
    status: "scheduled",
    series: "CRO Talks",
    episode: "#00"
  },
  {
    id: "3",
    title: "Oficina semanal de métricas e KPIs",
    description: "Sessão recorrente para análise de métricas importantes e definição de KPIs estratégicos.",
    start_iso: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    end_iso: new Date(Date.now() + 25 * 60 * 60 * 1000).toISOString(),
    location_type: "online",
    location_name: "Zoom",
    join_url: "https://zoom.us/j/123456789",
    speakers: "Time de Analytics",
    tags: "Métricas, KPIs, Analytics",
    cover_image: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800",
    rrule: "FREQ=WEEKLY;COUNT=4",
    series: "Workshops",
    episode: "Semanal"
  },
  {
    id: "4",
    title: "Masterclass: Otimização de Conversão Avançada",
    description: "Técnicas avançadas de CRO, testes A/B e personalização para maximizar conversões.",
    start_iso: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    end_iso: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000 + 2 * 60 * 60 * 1000).toISOString(),
    location_type: "online",
    location_name: "Microsoft Teams",
    join_url: "https://teams.microsoft.com/l/meetup-join/example",
    rsvp_url: "https://eventbrite.com/e/example",
    speakers: "Especialistas em CRO",
    tags: "CRO, Conversão, Testes A/B",
    cover_image: "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=800",
    status: "scheduled",
    series: "Masterclass",
    episode: "Especial",
    destaque: "Sim"
  }
];

export default sampleData;